interface SurfaceData {
  id: string
  label: string
  route: string
  ssr: string
  revalidation: string
  owner: string
  description: string
}

const surfaces: SurfaceData[] = [
  {
    id: 'search',
    label: 'Search',
    route: '/s?q=…',
    ssr: 'getServerSideProps (per request)',
    revalidation: 'None — live per request',
    owner: 'Shopper search query',
    description:
      'Full-text search with facets, sort, and pagination. Server prefetches the first page so products appear in HTML before JavaScript runs.',
  },
  {
    id: 'plp',
    label: 'Category PLP',
    route: '/:category-slug',
    ssr: 'getStaticProps + ISR',
    revalidation: 'On-demand via CMS webhook',
    owner: 'VTEX collection / category',
    description:
      'Category listings driven by VTEX collections. Category facets are passed to Unbxd via the bridge category endpoint. Always interactive without JS.',
  },
  {
    id: 'landing',
    label: 'Landing page',
    route: '/:landing-slug',
    ssr: 'getStaticProps + Unbxd prefetch',
    revalidation: '60 seconds (ISR)',
    owner: 'CMS merchandiser (UnbxdSearchResult)',
    description:
      'Promotional or brand pages authored in CMS. Fixed Unbxd query with optional price range and facets. URL does not change when shoppers filter.',
  },
]

/**
 * Renders tabbed comparison of Search, PLP, and Landing surfaces.
 */
export function renderSurfaceTabs(): string {
  const buttons = surfaces
    .map(
      (s, i) =>
        `<button type="button" class="surface-tabs__btn${i === 0 ? ' is-active' : ''}" data-surface-tab="${s.id}" aria-selected="${i === 0}">
          ${s.label}
        </button>`
    )
    .join('')

  const panels = surfaces
    .map(
      (s, i) =>
        `<div class="surface-tabs__panel" data-surface-panel="${s.id}"${i === 0 ? '' : ' hidden'}>
          <p style="margin:0 0 1rem;color:var(--color-text-muted)">${s.description}</p>
          <div class="surface-tabs__row"><span class="surface-tabs__label">Route</span><span class="surface-tabs__value"><code>${s.route}</code></span></div>
          <div class="surface-tabs__row"><span class="surface-tabs__label">Server strategy</span><span class="surface-tabs__value">${s.ssr}</span></div>
          <div class="surface-tabs__row"><span class="surface-tabs__label">Revalidation</span><span class="surface-tabs__value">${s.revalidation}</span></div>
          <div class="surface-tabs__row"><span class="surface-tabs__label">Content owner</span><span class="surface-tabs__value">${s.owner}</span></div>
        </div>`
    )
    .join('')

  return `<div class="surface-tabs" data-component="surface-tabs">
    <div class="surface-tabs__nav" role="tablist">${buttons}</div>
    ${panels}
  </div>`
}

/**
 * Initializes surface tab switching.
 */
export function initSurfaceTabs(root: ParentNode = document): void {
  const container = root.querySelector('[data-component="surface-tabs"]')
  if (!container) return

  const buttons = container.querySelectorAll<HTMLButtonElement>('[data-surface-tab]')
  const panels = container.querySelectorAll<HTMLElement>('[data-surface-panel]')

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.surfaceTab
      buttons.forEach((b) => {
        b.classList.toggle('is-active', b === btn)
        b.setAttribute('aria-selected', String(b === btn))
      })
      panels.forEach((p) => {
        const show = p.dataset.surfacePanel === id
        if (show) p.removeAttribute('hidden')
        else p.setAttribute('hidden', '')
      })
    })
  })
}
